























































































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';
import {BaseComponent} from '@/mixins/BaseComponent';

import {EventBus} from '@/utils/EventBus';
import {Time} from '@/utils/Time';

import {Level, Notification} from '@/model/Notification';

import {NotificationStore} from '@/store/Notification.store';

import NotificationsCenterList from '@/components/Notifications/NotificationsCenterList.vue';

@Component({
  components: {NotificationsCenterList},
})
export default class NotificationsCenter extends Mixins<BaseComponent>(BaseComponent) {
  private notificationStore: NotificationStore = getModule(NotificationStore, this.$store);

  private colorMap: Map<Level, string> = new Map([
    [Level.Success, 'success'],
    [Level.Info, 'info'],
    [Level.Warn, 'warning'],
    [Level.Error, 'error'],
  ]);

  private iconsMap: Map<Level, string> = new Map([
    [Level.Success, 'mdi-check-circle'],
    [Level.Info, 'mdi-information'],
    [Level.Warn, 'mdi-alert'],
    [Level.Error, 'mdi-close-octagon'],
  ]);

  private open: boolean = false;

  private historyOpen: boolean = false;

  private acknowledging: boolean = false;

  private clearing: boolean = false;

  get displayedNotifications(): Notification[] {
    return this.historyOpen ? this.notificationStore.AcknowledgedNotifications : this.notificationStore.ActiveNotifications;
  }

  private mounted() {
    EventBus.Register(EventBus.Event.OpenNotificationCenter, async () => {
      this.open = true;
      this.historyOpen = false;
    });
  }

  private acknowledge(id: string) {
    this.notificationStore.ackNotification(id);
  }

  private remove(id: string) {
    this.notificationStore.removeNotification(id);
  }

  private async dismissAll() {
    for (const notification of this.notificationStore.Notifications) {
      this.notificationStore.dismissNotification(notification.Id);
    }
  }

  private async acknowledgeAll(notifications: Notification[]) {
    this.acknowledging = true;

    const total = notifications.length;
    let count = 0;
    for (const notification of [...notifications].sort((a, b) => a.Order - b.Order)) {
      this.acknowledge(notification.Id);

      if (total - count < 10) {
        await Time.sleep(50);
      }
      count++;
    }
    this.acknowledging = false;
  }

  private async removeAll(notifications: Notification[]) {
    this.clearing = true;
    for (const notification of [...notifications].sort((a, b) => b.Order - a.Order)) {
      this.remove(notification.Id);
    }
    this.clearing = false;
  }
}
